class GuestServingEntity {
    id: number;
    tanggal: Date;
    shift: number;
    vendor: string;
    lokasi: string;
    customer_name: string;
    id_customer: number;
    payment: "QRIS" | "CASH";
    type: "REGULAR" | "VEGETARIAN";
  
    constructor(object: GuestServingEntity) {
      this.id = object.id;
      this.tanggal = object.tanggal;
      this.shift = object.shift;
      this.vendor = object.vendor;
      this.lokasi = object.lokasi;
      this.customer_name = object.customer_name;
      this.id_customer = object.id_customer;
      this.payment = object.payment;
      this.type = object.type;
    }
  }
  
  class AddGuestServingEntity {
    tanggal?: Date;
    shift?: 1 | 2 | 3 ;
    id_vendor_porsi?: number;
    outlet?: string;
    lokasi?: string;
    customer_name?: string;
    id_customer?: string;
    payment?: "QRIS" | "CASH" ;
    type?: "REGULAR" | "VEGETARIAN";
    porsi_reguler_available?: number;
    porsi_vegetarian_available?: number;
    constructor(object: AddGuestServingEntity) {
      this.tanggal = object.tanggal;
      this.shift = object.shift;
      this.id_vendor_porsi = object.id_vendor_porsi;
      this.outlet = object.outlet;
      this.lokasi = object.lokasi;
      this.customer_name = object.customer_name;
      this.id_customer = object.id_customer;
      this.payment = object.payment;
      this.porsi_reguler_available = object.porsi_reguler_available;
      this.porsi_vegetarian_available = object.porsi_vegetarian_available;
      this.type = object.type;
    }
  }
  
  export { GuestServingEntity, AddGuestServingEntity };